import { Routes } from '@angular/router';
import { LoginShell } from './shell/login-shell/login-shell.service';
import { Shell } from './shell/verified-shell/shell.service';

export const routes: Routes = [
  LoginShell.elekKommRoute([
    {
      path:          '',
      loadComponent: () =>
                       import('./modules/elekkomm-app/elekkomm-app.component').then((m) => m.ElekkommAppComponent)
    },
  ]),
  LoginShell.childRoutes([
    {
      path:          '',
      loadComponent: () =>
                       import('./modules/login/login-detail/login-detail.component').then((m) => m.LoginDetailComponent)
    },
    {
      path:          'resetpassword',
      loadComponent: () =>
                       import('./modules/login/login-detail/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'verify-user',
      loadComponent: () =>
                       import('./modules/login/user-not-identified/user-not-identified.component').then((m) => m.UserNotIdentifiedComponent)
    },
    {
      path:         'id-austria',
      loadComponent: () =>
                        import('./modules/login/user-not-identified/id-austria/id-austria.component').then((m) => m.IdAustriaComponent)
    },
    {
      path:          'nutzungsbedingungen',
      loadComponent: () =>
                       import('./modules/disclaimer/nutzungsbedingungen/nutzungsbedingungen.component').then((m) => m.NutzungsbedingungenComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'infos',
      loadComponent: () =>
                       import('./modules/disclaimer/meine-nv-informationen/meine-nv-informationen.component').then((m) => m.MeineNvInformationenComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'faq',
      loadComponent: () =>
                       import('./modules/disclaimer/faq/faq.component').then((m) => m.FaqComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'impressum',
      loadComponent: () =>
                       import('./modules/disclaimer/impressum/impressum.component').then((m) => m.ImpressumComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'datenschutz',
      loadComponent: () =>
                       import('./modules/disclaimer/datenschutz/datenschutz.component').then((m) => m.DatenschutzComponent),
      data:          {backButtonURL: '/login'}
    },
    {
      path:          'barrierefreiheit',
      loadComponent: () =>
                       import('./modules/disclaimer/barrierefreiheit/barrierefreiheit.component').then((m) => m.BarrierefreiheitComponent),
      data:          {backButtonURL: '/login'}
    }
  ]),
  Shell.childRoutes([
    {
      path:          '',
      loadComponent: () =>
                       import('./modules/home/home.component').then((m) => m.HomeComponent)

    },
    {
      path:          'news',
      loadComponent: () =>
                       import('./modules/content/news/news-overview/news-overview.component').then((m) => m.NewsOverviewComponent),
      data:          {backButtonURL: '/'}

    },
    {
      path:          'news/:id',
      loadComponent: () =>
                       import('./modules/content/news/news-detail/news-detail.component').then((m) => m.NewsDetailComponent),
      data:          {backButtonURL: '/'}
    },
    {
      path:          'polizzen',
      loadComponent: () =>
                       import('./modules/content/police/police-overview/police-overview.component').then((m) => m.PoliceOverviewComponent)

    },
    {
      path:          'polizzen/:id',
      loadComponent: () =>
                       import('./modules/content/police/police-detail/police-detail.component').then((m) => m.PoliceDetailComponent),
      data:          {backButtonURL: '/polizzen'}
    },
    {
      path:          'polizzen/:id/zahlungsart',
      loadComponent: () =>
                       import('./modules/content/police/police-detail/police-detail-zahlungsart/police-detail-zahlungsart.component').then((m) => m.PoliceDetailZahlungsartComponent),
      data:          {backButtonURL: '/polizzen'}
    },
    {
      path:          'schaeden',
      loadComponent: () =>
                       import('./modules/content/schaden/schaden-overview/schaden-overview.component').then((m) => m.SchadenOverviewComponent)

    },
    {
      path:          'schaeden/:id',
      loadComponent: () =>
                       import('./modules/content/schaden/schaden-detail/schaden-detail.component').then((m) => m.SchadenDetailComponent),
      data:          {backButtonURL: '/schaeden'}
    },
    {
      path:          'service',
      loadComponent: () =>
                       import('./modules/content/service/service-overview/service-overview.component').then((m) => m.ServiceOverviewComponent)

    },
    {
      path:          'service/schaden-melden',
      loadComponent: () =>
                       import('./modules/content/service/schaden-melden/schaden-melden.component').then((m) => m.SchadenMeldenComponent),
      data:          {backButtonURL: '/service'}

    },
    {
      path:          'service/soforthilfe',
      loadComponent: () =>
                       import('./modules/content/service/soforthilfe/soforthilfe.component').then((m) => m.SoforthilfeComponent),
      data:          {backButtonURL: '/service'}
    },
    {
      path:          'service/kontakte',
      loadComponent: () =>
                       import('./modules/content/service/contact-overview/contact-overview.component').then((m) => m.ContactOverviewComponent),
      data:          {backButtonURL: '/service'}
    },
    {
      path:          'service/wetterwarnung',
      loadComponent: () =>
                       import('./modules/content/service/wetterwarnung/wetterwarnung.component').then((m) => m.WetterwarnungComponent),
      data:          {backButtonURL: '/service'}
    },
    {
      path:          'service/gruenekarte',
      loadComponent: () =>
                       import('./modules/content/service/gruene-karte/gruene-karte.component').then((m) => m.GrueneKarteComponent),
      data:          {backButtonURL: '/service'}
    },
    {
      path:          'service/gruenekarte/polizze/:id',
      loadComponent: () =>
                       import('./modules/content/service/gruene-karte/gruene-karte.component').then((m) => m.GrueneKarteComponent),
      data:          {backButtonURL: '/service'}
    },
    {
      path:          'mehr',
      loadComponent: () =>
                       import('./modules/content/other/other-overview/other-overview.component').then((m) => m.OtherOverviewComponent)

    },
    {
      path:          'mehr/profil',
      loadComponent: () =>
                       import('./modules/content/other/profile/profile-overview.component').then((m) => m.ProfileOverviewComponent),
      data:          {backButtonURL: '/mehr'}

    },
    {
      path:          'mehr/profil/adressen',
      loadComponent: () =>
                       import('./modules/content/other/profile/change-address/change-address.component').then((m) => m.ChangeAddressComponent),
      data:          {backButtonURL: '/mehr/profil'}
    },
    {
      path:          'mehr/profil/adressen/polizze/:polnr',
      loadComponent: () =>
                       import('./modules/content/other/profile/change-address/change-address.component').then((m) => m.ChangeAddressComponent),
      data:          {backButtonURL: '/mehr/profil'}
    },
    {
      path:          'mehr/profil/name',
      loadComponent: () =>
                       import('./modules/content/other/profile/change-name/change-name.component').then((m) => m.ChangeNameComponent),
      data:          {backButtonURL: '/mehr/profil'}
    },
    {
      path:          'mehr/profil/email',
      loadComponent: () =>
                       import('./modules/content/other/profile/change-email/change-email.component').then((m) => m.ChangeEmailComponent),
      data:          {backButtonURL: '/mehr/profil'}
    },
    {
      path:          'mehr/profil/telnum',
      loadComponent: () =>
                       import('./modules/content/other/profile/change-telnum/change-telnum.component').then((m) => m.ChangeTelnumComponent),
      data:          {backButtonURL: '/mehr/profil'}
    },
    {
      path:          'mehr/nvlogin',
      loadComponent: () =>
                       import('./modules/content/other/nv-login/nv-login-settings/nv-login-settings.component').then((m) => m.NvLoginSettingsComponent),
      data:          {backButtonURL: '/mehr'}
    },
    {
      path:          'mehr/disclaimer/:type',
      loadComponent: () =>
                       import('./modules/content/other/logged-in-disclaimer/logged-in-disclaimer.component').then((m) => m.LoggedInDisclaimerComponent),
      data:          {backButtonURL: '/mehr'}
    },
    {
      path:          'benachrichtigungen',
      loadComponent: () =>
                       import('./modules/content/postfach/postfach-overview/postfach-overview.component').then((m) => m.PostfachOverviewComponent),
      data:          {backButtonURL: '/'}
    },
    {
      path:          'policepayments',
      loadComponent: () =>
                       import('./modules/content/police/police-upcoming-payments/police-upcoming-payments.component').then((m) => m.PoliceUpcomingPaymentsComponent),
      data:          {backButtonURL: '/'}
    }
  ]),
  {
    path:       '**', // Fallback
    redirectTo: '',
    pathMatch:  'full'
  }
];
